import {Urls} from '../constants'
import 'styles/productthree.scss'
import { currentUserInfo } from "../utils/currentUser.js";

(function(){
	/* global $ */
	'use strict';

	// Link to page
	// https://shop.buckscc.gov.uk/s4s/WhereILive/Council?pageId=2348&pid=bff75ea7-d950-4f25-8e7b-a5da00dd3692&supId=402f98b4-44b9-44ef-b3a5-a5c600de5a87&bcgId=fcea1611-2a26-4a1d-a4a6-b480f7423e14
    var productId = '';
	var supplierId = '';
    var bcg = '';
    
	var between = '';
	var and = '';

	// These are for the Wills database column headers
	var PBId = '';

	var url = window.location.href;

	// Get the Product ID from the URL
	var urlProductLength = url.split('&pid=');
	var urlProduct = url.split('&pid=').pop().split('&').shift();
	if (  urlProductLength.length === 1 ) {
		productId = '';
	} else {
		productId = urlProduct;
	}
//	 console.log('Product id is ' + productId);

	
	// Get the Supplier ID from the URL
	var urlSupLength = url.split('&supId=');
	var urlSup = url.split('&supId=').pop().split('&').shift();	
	if (  urlSupLength.length === 1 ) {
		supplierId = '';
	} else {
		supplierId = urlSup;
	}
//	 console.log('Supplier id is ' + supplierId);


	// Get the bcgId from the URL
	var urlBCGLength = url.split('&bcgId=');
	var urlBCG = url.split('&bcgId=').pop().split('&').shift();	
	if (  urlBCGLength.length === 1 ) {
		bcg = '';
	} else {
		bcg = urlBCG;
    }
    

    // Get the Virtual wallet type from the URL
	var VWType = '';
	var urlVWLength = url.split('&vw=');
	var urlVW = url.split('&vw=').pop().split('&').shift();
	if (  urlVWLength.length === 1 ) {
		VWType = '';
	} else {
		VWType = urlVW;
	}

	var totalCost = 0;
	var totalHours = 0;

	function overlay() {
		$('body').prepend(
			'<div class="js-overlay" style="width: 100%; height: 100%; position: fixed; z-index: 10000000; top: 0; display: flex; justify-content: center; background-color: rgba(0, 0, 0, 0.2)">' +
				'<svg style="width: 80px;" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-spinner fa-w-16 fa-spin fa-lg"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z" class=""></path></svg>' +
			'</div>'
		);
	}


	function checkAuth() {

		currentUserInfo(function(data) {
			if( data.PrivateBcgId !== null) {
				
				PBId = data.PrivateBcgId;
				getWillsData(PBId);

			} else { 

				$('.js-sign-in').html(
					'<div class="contentFixedMax">' +
						'<div class="mar-top2 circle-status border-colr-3">' +
							'<i class="fa fa-bar-chart" aria-hidden="true"></i>' +
						'</div>' +
						'<h1 class="mar-top1 mar-bot05 large">Welcome to Direct Payments</h1>' +
						'<h2 class="mar-bot1">' +
							'To access your Direct Payments dashboard please <a href="/s4s/Auth?ReturnUrl=%2fs4s%2fCustomPage%2fIndex%2f' + Urls.productthree + '">log in to your account</a>.' + 
						'</h2>' +
						'<p class="tint2 round pad10">' +
							'If you do not have an account please contact your administrator at..........' +
						'</p>' +
					'</div>'
				);

				$('.js-overlay').remove();
			}
		});		
	}


	function getWillsData(PBId) {

        $('.js-sign-in').addClass('hide');
        $('.js-dashboard-container').removeClass('hide');
		$('.js-main-nav').removeClass('hide');

		// Get dates
		var today = moment(new Date()).format("DD/MM/YYYY");
		var twelvemonth = moment(new Date()).subtract(1, 'years').format("DD-MM-YYYY");
		
		between = '&criterias[Between]=' + twelvemonth;		
		and = '&criterias[and]=' + today;



		var willsURL = '/s4s/vw/ProductThree/' + twelvemonth;
	//	console.log(willsURL);

		$.getJSON(willsURL).done(function (data) {

			for (var i = 0; i < data.length; i++) {

				var item = data[i];
				var itemBCG = item.bsId;
				
				var itemServiceProviderID = item.serviceProviderID;
				var itemServiceProviderName = item.serviceProviderName;
				var itemWeeklyHours = item.weeklyHours;
				var itemWeeklyCost = item.weeklyCost;
				var itemLastPaidAmount = item.lastPaidAmount;
				var itemLastPaidDate = item.lastPaidDate;
				var itemRepeatOrder = item.repeatOrder;

					//itemBCG = itemBCG.toUpperCase();
					
				
				totalCost += itemWeeklyCost;
				totalHours += itemWeeklyHours;                  

				// If Auth JSON PBId matches Mongo External JSON PBId
				//	if ( PBId === itemBCG ) {

				

				// If there are one off orders
				
				// if ( itemWeeklyCost === 0 && itemWeeklyHours === 0 && (itemServiceProviderID !== null && itemServiceProviderID !== '') && (itemServiceProviderName !== null && itemServiceProviderName !== '')) {
				
				if ( itemRepeatOrder === 0 ) {

					$('.js-one-off-container').removeClass('hide');

					$('.js-support-summary_one-off-container').removeClass('hide');

					// Desktop
					$('.js-support-summary_one-off-details-container').append(
						`
						<tr class="support-summary_item-container support-summary_item-container-desktop">
							<td class="support-summary_item support-summary_one-off-item-name"><a href="/s4s/OrdersDetails/Orders/${itemServiceProviderID}">${itemServiceProviderName}</a></td>
							<td class="support-summary_item support-summary_item-hours">${itemLastPaidDate}</td>
							<td class="support-summary_item support-summary_item-cost">£${itemLastPaidAmount}</td>
						</tr>
						`
					)
					
					// Mobile
					$('.js-support-summary_one-off-details-container').append(
						`
						<tr class="support-summary_item-container-mobile">
							<td class="support-summary_col-mobile">
								<p class="support-summary_heading-mobile">Provider</p>
								<p class="support-summary_name-data"><a href="/s4s/OrdersDetails/Orders/${itemServiceProviderID}">${itemServiceProviderName}</a></p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile"></p>
							<p class="support-empty-data"></p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Last paid</p>
							<p class="support-summary_paid-data">${itemLastPaidDate}</p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Amount</p>
							<p class="support-summary_amount-data">£${itemLastPaidAmount}</p>
							</td>
						</tr> 
						`
					)

				} 


				// If there are rpeating orders
				if ( itemWeeklyCost !== 0 && itemWeeklyHours !== 0 && (itemServiceProviderID !== null && itemServiceProviderID !== '') && (itemServiceProviderName !== null && itemServiceProviderName !== '')){
					
					// Desktop
					$('.js-support-summary_orders-details-container').append(
						`
						<tr class="support-summary_item-container support-summary_item-container-desktop">
							<td class="support-summary_item support-summary_item-name"><a href="/s4s/OrdersDetails/Orders/${itemServiceProviderID}">${itemServiceProviderName}</a></td>
							<td class="support-summary_item support-summary_item-hours">${itemWeeklyHours}</td>
							<td class="support-summary_item support-summary_item-cost">£${itemWeeklyCost}</td>
							<td class="support-summary_item support-summary_item-paid">${itemLastPaidDate}</td>
							<td class="support-summary_item support-summary_item-amount">£${itemLastPaidAmount}</td>
						</tr>
						`
					);
					
					// Mobile
					$('.js-support-summary_orders-details-container').append(
						`
						<tr class="support-summary_item-container-mobile">
							<td class="support-summary_col-mobile">
								<p class="support-summary_heading-mobile">Provider</p>
								<p class="support-summary_name-data"><a href="/s4s/OrdersDetails/Orders/${itemServiceProviderID}">${itemServiceProviderName}</a></p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile"></p>
							<p class="support-empty-data"></p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Last paid</p>
							<p class="support-summary_paid-data">${itemLastPaidDate}</p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Weekly cost</p>
							<p class="support-summary_cost-data">£${itemWeeklyCost}</p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Weekly hours</p>
							<p class="support-summary_hours-data">${itemWeeklyHours}</p>
							</td>
							<td class="support-summary_col-mobile">
							<p class="support-summary_heading-mobile">Amount</p>
							<p class="support-summary_amount-data">£${itemLastPaidAmount}</p>
							</td>
						</tr> 
						`
					);

				}

				

				// User is logged in but no matching PBId can be found
				// } else {

				// 	$('.js-sign-in').html(

				// 		'<div class="contentFixedMax">' +
				// 			'<div class="mar-top2 circle-status border-colr-3">' +
				// 				'<i class="fa fa-cogs" aria-hidden="true"></i>' +
				// 			'</div>' +
				// 			'<h1 class="mar-top1 mar-bot05 large">It appears your dashboards have not been configured yet</h1>' +
				// 			'<h2 class="mar-bot1">' +
				// 				'Please contact your administrator to get it activated.' + 
				// 			'</h2>' +
							
				// 		'</div>'

				// 	);
				// }

			}


			// If there are no repeating orders
			if($('.js-support-summary_orders-details-container .support-summary_item-container').length === 0){
				
				// Desktop
				$('.js-support-summary_orders-details-container').append(
					`
					<tr class="support-summary_item-container support-summary_item-container-desktop">
						<td class="support-summary_item support-summary_item-name">No current orders</td>
					</tr>
					`
				);
				
				// Mobile
				$('.js-support-summary_orders-details-container').append(
					`
					<tr class="support-summary_item-container-mobile">
						<td class="support-summary_col-mobile">
						<p class="support-summary_heading-mobile"></p>
						<p class="support-empty-data">No current orders</p>
						</td>
					</tr> 
					`
				);

			}
			
			
			// If there are no one off orders
			if($('.js-support-summary_one-off-container .support-summary_item-container').length === 0){
				
				// Desktop
				$('.js-support-summary_one-off-details-container').append(
					`
					<tr class="support-summary_item-container support-summary_item-container-desktop">
						<td class="support-summary_item support-summary_one-off-item-name">No current one off orders</td>
					</tr>
					`
				)
				
				// Mobile
				$('.js-support-summary_one-off-details-container').append(
					`
					<tr class="support-summary_item-container-mobile">
						<td class="support-summary_col-mobile">
						<p class="support-summary_heading-mobile"></p>
						<p class="support-empty-data">No current one off orders</p>
						</td>
					</tr> 
					`
				)
		
			}


			



			// NEW DESIGN CODE /////////////////////////
			$('.js-weekly-cost').html(`£${totalCost.toFixed(2)}`);
			$('.js-weekly-hours').html(`${totalHours}`);
			

			// $('.js-weekly-cost').html('<h3>Regular weekly cost: <strong>£' + totalCost.toFixed(2) + '</strong></h3>');
			// $('.js-weekly-hours').html('<h3 style="margin-bottom: 0.5em;">Total weekly hours: <strong>' + totalHours + ' hours</strong></h3>');

			$('.js-overlay').remove();


		})

		.fail(function () {

			$('.js-overlay').remove();
		});


	}

	




	var Attributes = {
		init: function() {
			this.adjustDom();
			this.bindUIActions();

			checkAuth();		
			// getOptions();

		},

		adjustDom: function() {
			
			overlay();

		},

		bindUIActions: function() {

            // Click fixed transactions button to dorp down to support-summary section
            var aTag = $(".support-summary_section[name='trans-section']");
            var headerHeight = $(".header-nav_section").height();
            var transSectionHeight = $({scrollTop: aTag.offset().top - headerHeight});
            
            $('#trans-scroll-btn').on('click', function(){
                $('html, body').animate({scrollTop: aTag.offset().top - headerHeight},'slow');
            })

            // Set transactions button display based on view on the screen
            $(document).on('scroll', function() {
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();
                var elemTop = $('.support-summary_section').offset().top;
                var elemBottom = elemTop + $('.support-summary_section').height();

                if((elemBottom <= docViewBottom) && (elemTop >= docViewTop)){
                    $('.support-summary-anchor_section').css('display', 'none');
                } else {
                    $('.support-summary-anchor_section').css('display', 'flex');
                }
            })



            // Select which summary items to show
            $('.js-support-summary_tab').on('click', function(e){

                e.preventDefault();
                $('.js-support-summary_tab').removeClass('active-tab');

                if($(this).hasClass('js-support-summary_orders-tab')){

                    $(this).addClass('active-tab');
					$('.js-tab-panel').attr('aria-labelledby', 'tab-2');
					$('.js-tab-panel').attr('id', 'tabpanel-2');
                    $('.js-support-summary_one-off-container').addClass('hide-summary-container');
                    $('.js-support-summary_orders-container').removeClass('hide-summary-container');

                } else if ($(this).hasClass('js-support-summary_one-off-tab')){

                    $(this).addClass('active-tab');
					$('.js-tab-panel').attr('aria-labelledby', 'tab-3');
					$('.js-tab-panel').attr('id', 'tabpanel-3');
                    $('.js-support-summary_orders-container').addClass('hide-summary-container');
                    $('.js-support-summary_one-off-container').removeClass('hide-summary-container');

                } else {

                    $(this).addClass('active-tab');
					$('.js-tab-panel').attr('aria-labelledby', 'tab-1');
					$('.js-tab-panel').attr('id', 'tabpanel-1');
                    $('.js-support-summary_orders-container').removeClass('hide-summary-container');
                    $('.js-support-summary_one-off-container').removeClass('hide-summary-container');
                }

            })

			$(document).on('keydown', function (e) {
				const btnSelectors =
					'.js-support-summary_all-tab, .js-support-summary_orders-tab, .js-support-summary_one-off-tab';

				const $buttons = $(btnSelectors).filter(':visible');
				const $focused = $(document.activeElement).closest(btnSelectors);

				if ($focused.length === 0) return;

				const idx = $buttons.index($focused);
				if (idx === -1) return;

				// LEFT or RIGHT
				if (e.which === 37 || e.which === 39) {
					e.preventDefault();

					const delta = (e.which === 39 ? 1 : -1);
					const len = $buttons.length;

					const nextIdx = (idx + delta + len) % len;
					const $next = $buttons.eq(nextIdx);

					updateAria($buttons, $next);
					$next.click().focus();
				}

				// ENTER
				if (e.which === 13) {
					e.preventDefault();
					updateAria($buttons, $focused);
					$focused.click();
				}

				// helper
				function updateAria($all, $selected) {
					$all.attr('aria-selected', 'false');
					$selected.attr('aria-selected', 'true');
				}
			});



            // Toggle the current balance info box
            $('.js-regular-weekly-info-box-toggle').on('click', function(e){
                e.stopPropagation();
                $('.js-total-weekly-info-box').addClass('hide-info-box');
                $('.js-regular-weekly-info-box').toggleClass('hide-info-box');
            })

            $('body').on('click', function(){
                $('.js-regular-weekly-info-box').addClass('hide-info-box');
            })
            

            // Toggle the available balance info box
            $('.js-total-weekly-info-box-toggle').on('click', function(e){
                e.stopPropagation();
                $('.js-regular-weekly-info-box').addClass('hide-info-box');
                $('.js-total-weekly-info-box').toggleClass('hide-info-box');
            })

            $('body').on('click', function(){
                $('.js-total-weekly-info-box').addClass('hide-info-box');
            })



			// Remove the lightbox
			$('body').on('click', '.reportCross', function(e){
				$('.js-overlay').remove();
				$('.popupcontainer').remove();
			});



		    $(window).on('hashchange',function(){ 
			    window.location.reload(); 
			});

		}
	};

	Attributes.init();

})();